import { Box } from '@mui/material';
import { styled } from '@mui/system';
import { theme } from '../../lib/index';

export const Stats = styled(Box, {})({
  display: 'flex',
  margin: '15px 0 20px',

  justifyContent: 'center',
  alignItems: 'center',
  gap: 10,

  [theme.breakpoints.up('laptop')]: {
    height: 31,

    flexDirection: 'row',
  },
});
